import { render } from "./CoinDropdown.vue?vue&type=template&id=61ab039d&scoped=true"
import script from "./CoinDropdown.vue?vue&type=script&lang=js"
export * from "./CoinDropdown.vue?vue&type=script&lang=js"

import "./CoinDropdown.vue?vue&type=style&index=0&id=61ab039d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ab039d"]])

export default __exports__